module.exports = __webpack_public_path__ + "img/img6.5623d9c2.jpg";